import React, { createContext, useContext, useState } from 'react';

export interface RoutinesStats {
  total: number;
  active: number;
  paused: number;
}

interface RoutinesStatsContextValue {
  stats: RoutinesStats;
  setStats: (stats: RoutinesStats) => void;
}

const RoutinesStatsContext = createContext<RoutinesStatsContextValue>({
  stats: { total: 0, active: 0, paused: 0 },
  setStats: () => {},
});

export const RoutinesStatsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [stats, setStats] = useState<RoutinesStats>({ total: 0, active: 0, paused: 0 });
  return (
    <RoutinesStatsContext.Provider value={{ stats, setStats }}>
      {children}
    </RoutinesStatsContext.Provider>
  );
};

export const useRoutinesStats = () => useContext(RoutinesStatsContext);
